module.exports = __webpack_public_path__ + "img/serviceStation.161cf61c.png";